(function () {
  var profileCache = {};
  var fitmentCache = {};

  function normalizeValue(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ł/g, "l")
      .replace(/&amp;/g, "&")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function toArray(value) {
    if (Array.isArray(value)) {
      return value;
    }

    if (value == null || value === "") {
      return [];
    }

    return [value];
  }

  function getDrawer() {
    return document.getElementById("sidebarDrawer");
  }

  function getFilterGroups(drawer) {
    return Array.prototype.slice.call(
      drawer.querySelectorAll(".filter-group[data-filter-key], .menu_list-ui[data-filter-key]")
    );
  }

  function getGroupsByKey(drawer, key) {
    return getFilterGroups(drawer).filter(function (group) {
      return group.dataset.filterKey === key;
    });
  }

  function getBlockForGroup(group) {
    return group.closest(".featured_block") || group;
  }

  function setHidden(element, isHidden) {
    element.hidden = isHidden;
    element.classList.toggle("d-none", isHidden);
  }

  function fetchJson(url) {
    if (!url) {
      return Promise.resolve(null);
    }

    return fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Cannot load JSON: " + url);
        }

        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function getProfileData(drawer) {
    var url = drawer.dataset.filterProfilesUrl || "";

    if (!url) {
      return Promise.resolve(null);
    }

    if (!profileCache[url]) {
      profileCache[url] = fetchJson(url);
    }

    return profileCache[url];
  }

  function getProfile(drawer, data) {
    var profiles = (data && data.profiles) || data || {};
    var profileName = drawer.dataset.filterProfile || "default";
    var profile = profiles[profileName] || profiles.default;

    if (Array.isArray(profile)) {
      profile = { filters: profile };
    }

    if (!profile || !Array.isArray(profile.filters)) {
      return null;
    }

    return profile;
  }

  function profileUsesFitments(profile) {
    return profile.filters.some(function (rule) {
      var allowedValues = rule && rule.allowed_values;
      return allowedValues && typeof allowedValues === "object" && allowedValues.source === "fitments";
    });
  }

  function flattenFitmentRecords(value, records) {
    if (Array.isArray(value)) {
      value.forEach(function (item) {
        flattenFitmentRecords(item, records);
      });
      return;
    }

    if (value && typeof value === "object") {
      if (Array.isArray(value.data)) {
        flattenFitmentRecords(value.data, records);
        return;
      }

      records.push(value);
    }
  }

  function valueName(item) {
    if (item == null) {
      return "";
    }

    if (typeof item !== "object") {
      return String(item);
    }

    return item.name || item.label || item.value || item.title || "";
  }

  function objectValues(value) {
    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === "object") {
      return Object.keys(value).map(function (key) {
        return value[key];
      });
    }

    return [value];
  }

  function buildFitmentMap(responses) {
    var records = [];
    var brands = new Map();

    responses.forEach(function (response) {
      flattenFitmentRecords(response, records);
    });

    records.forEach(function (record) {
      var brandName = valueName(record);
      var brandKey = normalizeValue(brandName);
      var modelItems = objectValues(record.field_2 || record.models || record.children);

      if (!brandKey || !modelItems.length) {
        return;
      }

      if (!brands.has(brandKey)) {
        brands.set(brandKey, new Set());
      }

      modelItems.forEach(function (model) {
        var modelKey = normalizeValue(valueName(model));

        if (modelKey) {
          brands.get(brandKey).add(modelKey);
        }
      });
    });

    return {
      loaded: records.length > 0,
      brands: brands
    };
  }

  function getFitments(drawer, profile) {
    if (!profileUsesFitments(profile)) {
      return Promise.resolve(null);
    }

    var urls = (drawer.dataset.fitmentUrls || "")
      .split(",")
      .map(function (url) {
        return url.trim();
      })
      .filter(Boolean);

    if (!urls.length) {
      return Promise.resolve(null);
    }

    var cacheKey = urls.join(",");

    if (!fitmentCache[cacheKey]) {
      fitmentCache[cacheKey] = Promise.all(
        urls.map(function (url) {
          return fetchJson(url);
        })
      ).then(function (responses) {
        return buildFitmentMap(responses.filter(Boolean));
      });
    }

    return fitmentCache[cacheKey];
  }

  function getActiveValues(drawer, key) {
    var values = new URLSearchParams(window.location.search).getAll(key);

    drawer.querySelectorAll("#mainFilterForm input").forEach(function (input) {
      if (input.name === key && input.value && !values.includes(input.value)) {
        values.push(input.value);
      }
    });

    getGroupsByKey(drawer, key).forEach(function (group) {
      group.querySelectorAll(".tags-link.active, .js-filter-link[data-active='true']").forEach(function (element) {
        var item = element.closest("[data-filter-value]");
        var value = (item && item.dataset.filterValue) || element.dataset.filterValue || "";

        if (value && !values.includes(value)) {
          values.push(value);
        }
      });
    });

    return values.filter(Boolean);
  }

  function getContextValues(drawer, source) {
    if (!source) {
      return [];
    }

    if (source === "context.vehicle_make") {
      return toArray(drawer.dataset.filterContextBrand).filter(Boolean);
    }

    if (source.indexOf("filter.") === 0) {
      return getActiveValues(drawer, source);
    }

    return toArray(source).filter(Boolean);
  }

  function isFilterSource(source) {
    return typeof source === "string" && source.indexOf("filter.") === 0;
  }

  function addDependency(dependencies, source, dependent) {
    if (!isFilterSource(source) || !dependent || source === dependent) {
      return;
    }

    if (!dependencies[source]) {
      dependencies[source] = [];
    }

    if (!dependencies[source].includes(dependent)) {
      dependencies[source].push(dependent);
    }
  }

  function collectConditionDependencies(dependencies, condition, dependent) {
    if (!condition) {
      return;
    }

    if (Array.isArray(condition)) {
      condition.forEach(function (item) {
        collectConditionDependencies(dependencies, item, dependent);
      });
      return;
    }

    addDependency(dependencies, condition.key || condition.source, dependent);
  }

  function collectAllowedValueDependencies(dependencies, allowedValues, dependent) {
    if (!allowedValues || Array.isArray(allowedValues) || typeof allowedValues !== "object") {
      return;
    }

    [
      allowedValues.vehicle_make_from,
      allowedValues.make_from,
      allowedValues.by,
      allowedValues.by_context,
      allowedValues.context_key
    ].forEach(function (source) {
      addDependency(dependencies, source, dependent);
    });
  }

  function buildDependencies(profile) {
    var dependencies = {};

    profile.filters.forEach(function (rule) {
      if (!rule || !rule.key) {
        return;
      }

      collectConditionDependencies(dependencies, rule.conditional_display, rule.key);
      collectAllowedValueDependencies(dependencies, rule.allowed_values, rule.key);
      toArray(rule.depends_on).forEach(function (source) {
        addDependency(dependencies, source, rule.key);
      });
    });

    return dependencies;
  }

  function paramValuesSignature(params, key) {
    return params
      .getAll(key)
      .map(String)
      .sort()
      .join("\n");
  }

  function filterParamChanged(targetUrl, source) {
    var currentUrl = new URL(window.location.href);

    return paramValuesSignature(currentUrl.searchParams, source) !== paramValuesSignature(targetUrl.searchParams, source);
  }

  function updateDependencyLinks(drawer, dependencies) {
    Object.keys(dependencies).forEach(function (source) {
      getGroupsByKey(drawer, source).forEach(function (group) {
        group.querySelectorAll(".js-filter-link[href]").forEach(function (link) {
          var url = new URL(link.href, window.location.origin);

          if (!filterParamChanged(url, source)) {
            return;
          }

          dependencies[source].forEach(function (dependent) {
            url.searchParams.delete(dependent);
          });

          link.href = url.pathname + url.search + url.hash;
        });
      });
    });
  }

  function conditionAllowsDisplay(drawer, condition) {
    if (!condition) {
      return true;
    }

    if (Array.isArray(condition)) {
      return condition.every(function (item) {
        return conditionAllowsDisplay(drawer, item);
      });
    }

    var operator = condition.operator || "has_value";
    var values = getContextValues(drawer, condition.key || condition.source);
    var expected = normalizeValue(condition.value);

    if (operator === "has_value") {
      return values.some(Boolean);
    }

    if (operator === "equals") {
      return values.some(function (value) {
        return normalizeValue(value) === expected;
      });
    }

    if (operator === "not_equals") {
      return values.every(function (value) {
        return normalizeValue(value) !== expected;
      });
    }

    return true;
  }

  function addValuesToSet(set, values) {
    var hasWildcard = false;

    toArray(values).forEach(function (item) {
      var value = valueName(item);

      if (value === "*") {
        hasWildcard = true;
        return;
      }

      var normalized = normalizeValue(value);

      if (normalized) {
        set.add(normalized);
      }
    });

    return hasWildcard;
  }

  function resolveMapValues(rule, drawer) {
    var valuesMap = rule.values || {};
    var contextSource = rule.by || rule.by_context || rule.context_key;
    var contextValues = getContextValues(drawer, contextSource);
    var allowed = new Set();
    var hasWildcard = false;

    contextValues.forEach(function (contextValue) {
      var normalizedContext = normalizeValue(contextValue);
      var mappedValues = valuesMap[contextValue] || valuesMap[normalizedContext];

      if (mappedValues) {
        hasWildcard = addValuesToSet(allowed, mappedValues) || hasWildcard;
      }
    });

    if (!allowed.size && valuesMap["*"]) {
      hasWildcard = addValuesToSet(allowed, valuesMap["*"]) || hasWildcard;
    }

    return hasWildcard ? "*" : allowed;
  }

  function resolveAllowedValues(rule, drawer, fitments) {
    var allowedValues = rule.allowed_values;

    if (!allowedValues || allowedValues === "*") {
      return "*";
    }

    if (Array.isArray(allowedValues)) {
      var allowed = new Set();
      return addValuesToSet(allowed, allowedValues) ? "*" : allowed;
    }

    if (typeof allowedValues !== "object") {
      return "*";
    }

    if (allowedValues.source === "fitments") {
      if (!fitments || !fitments.loaded) {
        return "*";
      }

      var source = allowedValues.vehicle_make_from || allowedValues.make_from || "filter.p.m.allegro.vehicle_make";
      var makes = getContextValues(drawer, source);
      var models = new Set();

      makes.forEach(function (make) {
        var modelSet = fitments.brands.get(normalizeValue(make));

        if (!modelSet) {
          return;
        }

        modelSet.forEach(function (model) {
          models.add(model);
        });
      });

      return models;
    }

    if (allowedValues.source === "map" || allowedValues.values) {
      return resolveMapValues(allowedValues, drawer);
    }

    return "*";
  }

  function isItemActive(item) {
    var link = item.querySelector(".js-filter-link");
    return item.classList.contains("active") || (link && link.dataset.active === "true");
  }

  function applyAllowedValues(group, rule, drawer, fitments) {
    var items = Array.prototype.slice.call(group.querySelectorAll("[data-filter-value]"));
    var allowedValues = resolveAllowedValues(rule, drawer, fitments);
    var visibleCount = 0;

    if (!items.length || allowedValues === "*") {
      items.forEach(function (item) {
        setHidden(item, false);
      });
      return true;
    }

    items.forEach(function (item) {
      var rawValue = item.dataset.filterValue || item.dataset.tagValue || "";
      var label = item.dataset.filterLabel || item.textContent || "";
      var isAllowed = allowedValues.has(normalizeValue(rawValue)) || allowedValues.has(normalizeValue(label));
      var isVisible = isAllowed || isItemActive(item);

      setHidden(item, !isVisible);

      if (isVisible) {
        visibleCount += 1;
      }
    });

    return visibleCount > 0;
  }

  function applyProfile(drawer, profile, fitments) {
    var rules = {};
    var dependencies = buildDependencies(profile);

    profile.filters.forEach(function (rule) {
      if (rule && rule.key) {
        rules[rule.key] = rule;
      }
    });

    updateDependencyLinks(drawer, dependencies);

    getFilterGroups(drawer).forEach(function (group) {
      var key = group.dataset.filterKey;
      var rule = rules[key];
      var block = getBlockForGroup(group);
      var isVisible = !!rule && conditionAllowsDisplay(drawer, rule.conditional_display);

      if (isVisible) {
        isVisible = applyAllowedValues(group, rule, drawer, fitments);
      }

      setHidden(block, !isVisible);
    });
  }

  function apply() {
    var drawer = getDrawer();

    if (!drawer) {
      return Promise.resolve();
    }

    return getProfileData(drawer)
      .then(function (data) {
        if (!data) {
          return null;
        }

        var profile = getProfile(drawer, data);

        if (!profile) {
          return null;
        }

        return getFitments(drawer, profile).then(function (fitments) {
          applyProfile(drawer, profile, fitments);
        });
      })
      .catch(function () {
        return null;
      });
  }

  function initDrawerToggle() {
    if (!document.body.classList.contains("template-search")) {
      return;
    }

    var drawer = getDrawer();

    if (!drawer) {
      return;
    }

    Array.prototype.slice.call(document.querySelectorAll(".js-toggle-sb[data-role]")).forEach(function (button) {
      if (button.dataset.autolandDrawerBound === "true") {
        return;
      }

      button.dataset.autolandDrawerBound = "true";
      button.addEventListener("click", function (event) {
        var targetId = button.dataset.target;

        if (targetId && targetId !== drawer.id) {
          return;
        }

        event.preventDefault();

        if (button.dataset.role === "open") {
          drawer.classList.add("is-open");
        }

        if (button.dataset.role === "close") {
          drawer.classList.remove("is-open");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    apply();
    initDrawerToggle();
  });
  document.addEventListener("shopify:section:load", function () {
    apply();
    initDrawerToggle();
  });
  window.addEventListener("popstate", apply);

  window.AutolandCollectionFilters = {
    apply: apply
  };
})();
